import React from 'react';
import { withRouter, Route} from 'react-router-dom';
import './index.css' 

const VirtualTeams = ( {match, history} ) => {
    history.push(match.url + '/manage-virtual-teams')
    return (
        <div></div>
    )
}


export default withRouter(VirtualTeams)


// WEBPACK FOOTER //
// ./src/_pages/Organzation/Analyze/Category/VirtualTeams/index.js